var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128052(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.72,
    y1: 51.96,
    x2: 16.35,
    y2: 50.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "92.44 54.23 64.57 60 36.71 54.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 112.8,
    y1: 50.02,
    x2: 103.43,
    y2: 51.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.72,
    y: 46.6,
    width: 10.99,
    height: 16.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.43,
    y: 46.6,
    width: 10.99,
    height: 16.82
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "50.7 29 50.7 18.61 78.45 18.61 78.45 29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.35,38.25h4.39a5,5,0,0,0,5-5V29.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.8,38.25h-4.39a5,5,0,0,1-5-5V29.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.8,91.09h-4.39a5,5,0,0,0-5,5V99.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.35,
    y: 29,
    width: 96.44,
    height: 70.7,
    rx: 2.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.35,91.09h4.39a5,5,0,0,1,5,5V99.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128052);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_052.eb7a85e2ea732d793251e572e0d64050.svg";
export { ForwardRef as ReactComponent };